import { Tooltip } from '@project44/entity-ui-utils';
import { useFlags } from '@project44/feature-flags';
import { Box, CSS, styled, Typography } from '@project44/manifest-ds';
import { DateFormat, formatDateTime } from '@project44/ui-utils';

import DateDiff from '../DateDiff';
import DateTimeWindow from '../DateTimeWindow';
import PredictionIcon from './PredictionIcon';

const PredictedBox = styled('div', {
  backgroundColor: '$palette-purple-50',
  borderRadius: '2px',
  padding: '2px 8px',
  position: 'relative',
  width: 'fit-content',
});

interface PredictedDateProps {
  css?: CSS;
  differenceMsg?: { text: string; color: string; tooltip: string } | null; // Deprecated
  displayTimezoneAbbreviation?: boolean;
  estimateDateTime?: string; // Deprecated
  plannedEndDate?: string;
  plannedStartDate?: string;
  predictedDate?: string;
  timeZone?: string;
}

export const PredictedDate = ({
  estimateDateTime = '',
  differenceMsg,
  displayTimezoneAbbreviation,
  css,
  predictedDate,
  plannedEndDate,
  plannedStartDate,
  timeZone,
}: PredictedDateProps) => {
  const { featureVoc1463 } = useFlags();

  if (!estimateDateTime && !predictedDate)
    return (
      <Typography
        variant="subtext"
        data-testid="predicted-date-empty"
        css={css}
      >
        -
      </Typography>
    );

  return (
    <PredictedBox data-testid="predicted-date">
      <Box as="span" data-testid="predicted-date-time">
        {featureVoc1463 && predictedDate ? (
          <DateTimeWindow
            displayTimezoneAbbreviation={displayTimezoneAbbreviation}
            endDateTime={predictedDate}
            startDateTime={predictedDate}
            timeZone={timeZone}
          />
        ) : (
          formatDateTime({
            dateTime: estimateDateTime,
            dateFormat: DateFormat.monthDayYearHourMinute,
          }) || '-'
        )}
      </Box>
      <PredictionIcon
        sx={{ position: 'absolute', top: '7px', left: '-18px' }}
      />
      {featureVoc1463 && (
        <DateDiff
          predictedDate={predictedDate}
          plannedEndDate={plannedEndDate}
          plannedStartDate={plannedStartDate}
        />
      )}
      {!featureVoc1463 && differenceMsg && (
        <Tooltip message={differenceMsg.tooltip}>
          <Box
            data-testid="predicted-date-diff"
            as="span"
            css={{
              fontWeight: '$semibold',
              marginLeft: '6px',
              color: differenceMsg.color,
            }}
          >
            {differenceMsg.text}
          </Box>
        </Tooltip>
      )}
    </PredictedBox>
  );
};

export default PredictedDate;
